/* Imports */
import IncidentService from "@/services/incident.service";
/* /Imports/ */

/* 
  Module: IncidentsTableModule
  Description: This module representing different actions with incidents.
*/
export const incidentTable = {
    /*
      Self-contained/reusable module.
    */
    namespaced: true,

    /*
      Default states in this module.
    */
    state: {
        incidentData: null,
        myPersonalIncidents: null,
        myTeamsIncidents: null
    },

    /*
      Define actions for separate different logic. 
    */
    actions: {
        /* 
          Call IncidentService class then dispatch all incidents action.
        */
        getAllIncidents({ commit }) {
            return IncidentService.getAllIncidents().then(
                (response) => {
                    commit("dataSuccessIncidents", response.incidents);
                    return Promise.resolve(response.incidents);
                }
            )
        },

        /* 
          Call IncidentService class then dispatch user incidents action.
        */
        getMyPersonalIncidents({ commit }, token) {
            return IncidentService.getMyIncidents(token).then(
                (response) => {
                    commit("dataSuccessMyPersonalIncidents", response.incidents);
                    return Promise.resolve(response.incidents);
                }
            )
        },

        /* 
          Call IncidentService class then dispatch user incidents action.
        */
        getMyTeamsIncidents({ commit }, token) {
            return IncidentService.getTeamsIncidents(token).then(
                (response) => {
                    commit("dataSuccessMyTeamsIncidents", response.incidents);
                    return Promise.resolve(response.incidents);
                }
            )
        },
    },

    /*
      Define mutations for separate different states. 
    */
    mutations: {
        /* 
          If data for all incidents is successfully obtained.
        */
        dataSuccessIncidents(state, incidentData) {
            state.incidentData = incidentData;
        },

        /* 
          If data for user personal incidents is successfully obtained.
        */
        dataSuccessMyPersonalIncidents(state, myPersonalIncidents) {
            state.myPersonalIncidents = myPersonalIncidents;
        },

        /* 
          If data for user teams incidents is successfully obtained.
        */
        dataSuccessMyTeamsIncidents(state, myTeamsIncidents) {
            state.myTeamsIncidents = myTeamsIncidents;
        }
    }
};
